import { __zcFin, __zcIT, __zcITc, __zcMkv, __zcRd, __zcRf } from "__zod-compiler-runtime__";
import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'

export const PrimerComponentAnchorLinkSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('primerComponentAnchorLink', {
  fields: z.lazy(() =>
    z.object({
      href: z.string(),
      text: z.string(),
      ariaLabel: z.string().optional(),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"]];
var __rfz_0=__rf[0]._zod;
function safeParse_PrimerComponentAnchorLinkSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_2=_d["sys"];if(typeof __sv_2!=="object"||__sv_2===null||Array.isArray(__sv_2)){_e.push(__zcIT("object",__sv_2,["sys"]));}else{var __sv_4=__sv_2["id"];if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","id"]));}
var __sv_5=__sv_2["updatedAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","updatedAt"]));}
}
var __sv_6=__sv_2["createdAt"];if(__sv_6!==undefined){if(typeof __sv_6!=="string"){_e.push(__zcIT("string",__sv_6,["sys","createdAt"]));}
}
var __sv_7=__sv_2["contentType"];var __op_9="contentType" in __sv_2;var __ob_8=_e.length;var __rf_c0={async:false};var __rf_r0=__zcRd(__rfz_0,__sv_7,__rf_c0);if(__rf_r0.issues.length){__zcRf(__rf_r0.issues,__rf_c0,_e,["sys","contentType"]);}else{__sv_7=__rf_r0.value;}
if(!__op_9){__sv_7=undefined;if(_e.length===__ob_8){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_3={"id":__sv_4};if(__sv_5!==undefined||("updatedAt" in __sv_2)){__o_3["updatedAt"]=__sv_5;}if(__sv_6!==undefined||("createdAt" in __sv_2)){__o_3["createdAt"]=__sv_6;}if(__sv_7!==undefined||("contentType" in __sv_2)){__o_3["contentType"]=__sv_7;}__sv_2=__o_3;}
var __sv_10=_d["fields"];if(typeof __sv_10!=="object"||__sv_10===null||Array.isArray(__sv_10)){_e.push(__zcIT("object",__sv_10,["fields"]));}else{var __sv_12=__sv_10["href"];if(typeof __sv_12!=="string"){_e.push(__zcIT("string",__sv_12,["fields","href"]));}
var __sv_13=__sv_10["text"];if(typeof __sv_13!=="string"){_e.push(__zcIT("string",__sv_13,["fields","text"]));}
var __sv_14=__sv_10["ariaLabel"];if(__sv_14!==undefined){if(typeof __sv_14!=="string"){_e.push(__zcIT("string",__sv_14,["fields","ariaLabel"]));}
}
var __o_11={"href":__sv_12,"text":__sv_13};if(__sv_14!==undefined||("ariaLabel" in __sv_10)){__o_11["ariaLabel"]=__sv_14;}__sv_10=__o_11;}
var __o_1={"sys":__sv_2,"fields":__sv_10};_d=__o_1;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_PrimerComponentAnchorLinkSchema,__zs,null,null);
})()

export type PrimerComponentAnchorLink = z.infer<typeof PrimerComponentAnchorLinkSchema>
